exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".characteristics-block[data-v-4cc8f6c8],.characteristics-block .title[data-v-4cc8f6c8]{font-size:.875rem}@media (min-width:768px){.characteristics-block .title[data-v-4cc8f6c8]{padding-top:.75rem}}", ""]);

